import { useState } from 'react';
import {
  GET_PRODUCTS_ENDPOINT,
  GET_RELATED_PRODUCT,
} from '../_libs/utils/constants/endpoints';
import { useQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'next/navigation';

//use to get all products for search page ********
async function getAllProducts({ filters }) {
  const data = await fetch(`${GET_PRODUCTS_ENDPOINT}?${filters}`);
  const resdata = await data.json();
  return resdata;
}
async function getRelatedProducts(slug) {
  const data = await fetch(`${GET_RELATED_PRODUCT}/${slug}`);
  return data.json();
}
// use to get products of specific category ********
async function getProductsCategory({ id, filters }) {
  var str = '';
  if (Object.keys(filters).length > 0) {
    str = Object.keys(filters)
      .map(function (key) {
        return key + '=' + filters[key];
      })
      .join('&');
  }
  const data = await fetch(`${GET_PRODUCTS_ENDPOINT}?category[0]=${id}&${str}`);
  const resdata = await data.json();
  return resdata.data;
}

async function getProductsBrand(id, params) {
  const data = await fetch(`${GET_PRODUCTS_ENDPOINT}?brand[0]=${id}&${params}`);
  const resdata = await data.json();
  return resdata.data;
}
//  use to get single product info **********
async function getProduct(slug) {
  // const fallback = [];
  const data = await fetch(`${GET_PRODUCTS_ENDPOINT}/${slug}`);
  const resdata = await data.json();
  return resdata;
}
// all hooks related to product *******************************************
//*********************************************************************** */
const useProduct = (slug, initiaData) => {
  return useQuery({
    queryKey: ['product', slug],
    queryFn: getProduct(slug),
    initialData: initiaData,
    staleTime: 60000,
  });
};

const useRelatedProducts = (slug) => {
  const fallback = [];
  const { data: relatedProducts = fallback } = useQuery({
    queryKey: ['relatedProducts', slug],
    queryFn: () => getRelatedProducts(slug),
  });
  return { relatedProducts };
};

const useAllProducts = () => {
  const params = useParams();
  delete params.slug;
  const query = params;
  const [filters, setFilters] = useState({ ...query });
  const fallback = [];
  const { data: products = fallback } = useQuery({
    queryKey: ['products', filters],
    queryFn: () => getAllProducts({ filters }),
  });

  return { products, filters, setFilters };
};

const useProductsCategory = (id, initiaData) => {
  const params = useParams();
  const query = params;
  const [filters, setFilters] = useState({ ...query });
  const fallback = [];
  const { data: products = fallback } = useQuery({
    queryKey: ['products', id, filters],
    queryFn: () => getProductsCategory({ id, filters }),
    initialData: initiaData,
  });
  return { products, filters, setFilters };
};

const useProductsBrand = (id, initiaData) => {
  const params = useSearchParams();
  const query = params.toString();
  const [filters, setFilters] = useState(query);
  const fallback = [];
  const { data: products = fallback } = useQuery({
    queryKey: ['products', id, filters],
    queryFn: () => getProductsBrand(id, filters),
    initialData: initiaData,
  });
  return { products, filters, setFilters };
};
export {
  useProduct,
  useAllProducts,
  useProductsBrand,
  useProductsCategory,
  useRelatedProducts,
  getProduct,
};
